export default {
    Main: 'Main',
    UserBox: 'UserBox'
};